export const cloudName = 'dpkf2mzcd';
export const uploadPreset = 'lhe8xqsr';
export const urlRoot = `https://res.cloudinary.com/${cloudName}/image/upload`;
